module.exports = __webpack_public_path__ + "media/img/mask/angle-98b97af65168fb984f476c5f5d5f0645.svg";